import { GenericHierarchyFlow } from 'common/components/PreviewApprovalHierarchyReactFlow'; // Adjust path as needed
import { ApprovalMapFields } from 'common/graphql/__generated__/ApprovalMapFields';
import React from 'react';
import { NodeView } from '../../NodeView';
import {
  PurchaseOrderPreviewApprovalMap,
  PurchaseOrderPreviewApprovalMapVariables,
} from './__generated__/PurchaseOrderPreviewApprovalMap';

import PURCHASE_ORDER_PREVIEW_APPROVAL_MAP from './PurchaseOrderPreviewApprovalMap.graphql';

export interface HierarchyNode extends ApprovalMapFields {
  children?: HierarchyNode[];
  x?: number;
  y?: number;
}

interface HierarchyProps {
  entityId: string;
}

export const Hierarchy: React.FC<HierarchyProps> = ({ entityId }) => {
  const getNodesFromData = (data: PurchaseOrderPreviewApprovalMap) => {
    return data?.purchaseOrderPreviewApprovalMap?.nodes?.map((node) => ({
      ...node,
      level: node.level ?? 0,
      width: 300,
      height: 200,
      children: [], // Ensure children is included
    }));
  };

  return (
    <GenericHierarchyFlow<
      PurchaseOrderPreviewApprovalMap,
      PurchaseOrderPreviewApprovalMapVariables
    >
      entityId={entityId}
      query={PURCHASE_ORDER_PREVIEW_APPROVAL_MAP}
      queryVariables={{
        entityId: entityId!,
      }}
      getNodesFromData={getNodesFromData}
      NodeViewComponent={(props) => (
        <NodeView
          nodeData={props.data as unknown as HierarchyNode}
          key={props.data.id}
        />
      )}
    />
  );
};
